<template>
  <div class="gongjijin-page common-bg">
    <div class="gongjijin-header">
      <div class="header-row">
        <div class="header-left">
          <div class="header-label">已累计充值</div>
          <div class="header-amount">{{ totalRecharge }}</div>
          <div class="recharge-wrap">
            <div class="recharge-btn" @click="handleRecharge">
              <span class="btn-tag">送30%</span>
              充值
            </div>
          </div>
        </div>
        <div class="header-right">
          <div class="header-label">公积金</div>
          <div class="header-amount gold">{{ gongjijinAmount }}</div>
          <div class="withdraw-btn" @click="handleWithdraw">取出</div>
        </div>
      </div>
      <div class="bonus-info">
        <span class="bonus-text">赠送封顶<span class="white-text">不限顶</span></span>
        <span class="bonus-text">次数封顶<span class="white-text">不限顶</span></span>
      </div>
    </div>
    <div class="tabs-bar">
      <div class="tab-item" v-for="(tab, idx) in tabs" :key="idx" 
           :class="{ active: activeTab === idx }" @click="activeTab = idx">
        {{ tab.name }}
      </div>
    </div>

    <div class="tab-content" v-if="activeTab === 0">
      <div class="filter-row">
        <div class="filter-item" @click="showTime = !showTime">
          <span>{{ timeOptions[timeIndex].text }}</span>
          <van-icon name="arrow-down" size="10" />
          <div class="filter-dropdown" v-show="showTime">
            <div v-for="(opt, idx) in timeOptions" :key="idx" 
                 class="filter-option" :class="{ active: timeIndex === idx }"
                 @click="timeIndex = idx; showTime = false;">{{ opt.text }}</div>
          </div>
        </div>
        <div class="total-amount">总累积 {{ totalAmount }}</div>
      </div>

      <div class="record-list" v-if="recordList.length > 0">
        <div class="record-item" v-for="(item, index) in recordList" :key="index">
          <div class="record-time">{{ item.time }}</div>
          <div class="record-type">{{ item.type }}</div>
          <div class="record-amount" :class="item.amountType">{{ item.amount }}</div>
        </div>
      </div>
      <div class="record-empty" v-else>
        <div class="empty-icon-wrap">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
        </div>
        <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
      </div>
    </div>

    <div class="tab-content" v-else-if="activeTab === 1">
      <div class="filter-row">
        <div class="filter-item" @click="showTime = !showTime">
          <span>{{ timeOptions[timeIndex].text }}</span>
          <van-icon name="arrow-down" size="10" />
          <div class="filter-dropdown" v-show="showTime">
            <div v-for="(opt, idx) in timeOptions" :key="idx" 
                 class="filter-option" :class="{ active: timeIndex === idx }"
                 @click="timeIndex = idx; showTime = false;">{{ opt.text }}</div>
          </div>
        </div>
        <div class="total-amount">还需投注 {{ betAmount }}</div>
      </div>

      <div class="record-list" v-if="betRules.length > 0">
        <div class="record-item" v-for="(item, idx) in betRules" :key="idx">
          <div class="record-time">{{ item.category }}</div>
          <div class="record-type">{{ item.platform }}</div>
          <div class="record-amount">{{ item.requirement }}</div>
        </div>
      </div>
      <div class="record-empty" v-else>
        <div class="empty-icon-wrap">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
        </div>
        <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
      </div>
    </div>

    <div class="tab-content" v-else-if="activeTab === 2">
      <div class="rule-content">
        <div class="rule-item" v-for="(item, idx) in rules" :key="idx">
          <div class="rule-text no-circle">{{ item.num }}、{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gongjijinComponents',
  data() {
    return {
      activeTab: 0,
      timeIndex: 0,
      showTime: false,
      totalRecharge: '0.00',
      gongjijinAmount: '0.00',
      totalAmount: '0.00',
      betAmount: '0.00',
      tabs: [
        { name: '累积记录', id: 0 },
        { name: '累积投注要求', id: 1 },
        { name: '规则说明', id: 2 },
      ],
      timeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '本月', value: 3 },
        { text: '全部', value: 4 },
      ],
      recordList: [],
      betRules: [],
      rules: [
        { num: '1', text: '赠送方式：每次充值≥10.00，会赠送充值金额30%的奖金，该奖金会存放至公积金账户中，充值越多，奖励越多。' },
        { num: '2', text: '取出条件：每次充值都会累积新的公积金，所以每次都要完成该次充值金额的50倍有效投注，才能取出公积金；若公积金全元赠送或已封顶的，则需要完成该次充值的1倍有效投注' },
        { num: '3', text: '赠送次数：活动周期内，不限赠送次数，公积金累计针对赠的封顶则：活动周期内；赠送封顶：活动周期内，公积金累计金额上限无。' },
        { num: '4', text: '重置周期：公积金有效期为每季度，周期结束7天后未取出，则公积金奖励过期作废。' },
        { num: '5', text: '赠金倍数：取出公积金奖金需20倍有效投注，才能申请' },
        { num: '6', text: '领取限制：仅限Android APP、iOS APP移动端领取，公积金奖励在有效期内，仅可领取1次。' },
        { num: '7', text: '合规声明：仅限账号本人进行正常的人为操作，禁止租售、使用外挂、机器人、不同账号对赌、互刷、套利、代' },
      ],
    };
  },
  methods: {
    handleRecharge() {
      this.$root.showTost(0, '充值功能开发中');
    },
    handleWithdraw() {
      this.$root.showTost(0, '提取功能开发中');
    },
  },
};
</script>

<style lang="scss" scoped>
.gongjijin-page {
  min-height: 80vh;
  margin-top: 44px;
  padding-bottom: 100px;

  .gongjijin-header {
    display: flex;
    flex-direction: column;
    background: #292A2C;
    padding: 15px;

    .header-row {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      .header-left, .header-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;
      }
    }

    .header-left {
      border-right: 1px solid #3B3C3D;
    }

    .header-label {
      font-size: 12px;
      color: #888;
      margin-bottom: 8px;
    }

    .header-amount {
      font-size: 24px;
      color: #fff;
      font-weight: bold;
      margin-bottom: 10px;

      &.gold {
        color: #DFB372;
      }
    }

    .recharge-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .recharge-btn {
        background: #DFB372;
        color: #1E1F24;
        font-size: 12px;
        padding: 6px 30px;
        border-radius: 4px;
        position: relative;

        .btn-tag {
          position: absolute;
          top: -5px;
          right: -5px;
          background: #32CD32;
          color: #fff;
          font-size: 10px;
          padding: 2px 4px;
          border-radius: 2px;
        }
      }

      .recharge-desc {
        font-size: 10px;
        color: #888;
        margin-top: 5px;
      }
    }

    .withdraw-btn {
      background: #3B3C3D;
      color: #fff;
      font-size: 12px;
      padding: 6px 30px;
      border-radius: 4px;
    }
  }

  .bonus-info {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 10px;
    background: #1E1F24;

    .bonus-text {
      font-size: 12px;
      color: #888;

      .white-text {
        color: #fff;
      }
    }
  }

  .tabs-bar {
    display: flex;
    background: #292A2C;
    padding: 0 15px;

    .tab-item {
      flex: 1;
      padding: 15px 0;
      text-align: center;
      font-size: 14px;
      color: #888;
      position: relative;

      &.active {
        color: #DFB372;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 40px;
          height: 2px;
          background: #DFB372;
        }
      }
    }
  }

  .tab-content {
    padding: 15px;

    .filter-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .filter-item {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 6px 12px;
        background: #292A2C;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        position: relative;

        .filter-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin-top: 4px;
          background: #292A2C;
          border-radius: 4px;
          overflow: hidden;
          z-index: 100;

          .filter-option {
            padding: 10px;
            text-align: center;
            font-size: 12px;
            color: #888;

            &.active {
              color: #DFB372;
              background: rgba(223, 179, 114, 0.1);
            }
          }
        }
      }

      .total-amount {
        font-size: 12px;
        color: #DFB372;
      }
    }

    .record-list {
      background: #292A2C;
      border-radius: 8px;
      overflow: hidden;

      .record-item {
        display: flex;
        padding: 12px;
        border-bottom: 1px solid #3B3C3D;

        &:last-child {
          border-bottom: none;
        }

        .record-time {
          flex: 1;
          font-size: 12px;
          color: #888;
        }

        .record-type {
          flex: 1;
          font-size: 12px;
          color: #fff;
          text-align: center;
        }

        .record-amount {
          flex: 1;
          font-size: 12px;
          color: #DFB372;
          text-align: right;

          &.minus {
            color: #ff4d4f;
          }
        }
      }
    }

    .record-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 0;

      .empty-icon-wrap {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.4rem;

        .empty-icon {
          width: 2.5rem;
          height: 2.5rem;
          opacity: 0.5;
        }
      }

      .empty-text {
        font-size: 0.28rem;
        color: #666;

        .empty-link {
          color: #DFB372;
        }
      }
    }

    .rule-content {
      background: #292A2C;
      border-radius: 8px;
      padding: 15px;

      .rule-item {
        display: flex;
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }

        .rule-num {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #1E1F24;
          color: #DFB372;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          flex-shrink: 0;
        }

        .rule-text {
          font-size: 12px;
          color: #888;
          line-height: 1.6;

          &.no-circle {
            display: block;
            color: #999;
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/component/gongjijin.vue